/* eslint-disable import/prefer-default-export */
const currencyFormatter = require('currency-formatter');

const currency = {};
currency.currencyFormat = (price) => currencyFormatter.format(price, { code: 'BDT' });
export const { currencyFormat } = currency;
